import { TireSetRelocateSceneProps, TireSetRelocateStepText } from "./types";

export const TIRE_SET_RELOCATE_WAREHOUSE_STEP = 0;
export const TIRE_SET_RELOCATE_SUMMARY_STEP = 1;

/** Naslov i objašnjenje ispod scene, po koraku. */
export const TIRE_SET_RELOCATE_INTRO_TEXTS: Record<number, TireSetRelocateStepText> = {
  [TIRE_SET_RELOCATE_WAREHOUSE_STEP]: {
    title: "Premjestite set guma",
    description: "Odaberite novo skladište i datum premještaja. Set seli s jedne police na drugu.",
  },
  [TIRE_SET_RELOCATE_SUMMARY_STEP]: {
    title: "Provjerite premještaj",
    description: "Pregledajte premještaj prije potvrde. Staro skladište ostaje zapisano u povijesti seta.",
  },
};

/** Primjeri dok korisnik ništa nije odabrao. */
export const TIRE_SET_RELOCATE_INTRO_SAMPLE = {
  fromWarehouse: "Skladište Jankomir",
  toWarehouse: "Skladište Sesvete",
};

/** Oznaka kad je skladište odabrano, a naziv još nije razriješen. */
export const TIRE_SET_RELOCATE_SELECTED_WAREHOUSE = "Odabrano skladište";

/** Ishodišno i odredišno skladište: stvarni nazivi, oznaka odabira ili primjer. */
export const getRelocateRoute = ({ currentSet, formValues, targetWarehouseName }: TireSetRelocateSceneProps) => ({
  from: currentSet.warehouse?.name || TIRE_SET_RELOCATE_INTRO_SAMPLE.fromWarehouse,
  to:
    targetWarehouseName ||
    (formValues.targetWarehouseId ? TIRE_SET_RELOCATE_SELECTED_WAREHOUSE : TIRE_SET_RELOCATE_INTRO_SAMPLE.toWarehouse),
});
